import { useLocation, Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactUsDialog from "components/ModalDialogs/ContactUsDialog";
import { getImage } from "js/utilities";
import config from "config/config";

export default function FooterWLP({ portal }) {
  const location = useLocation();
  const { t } = useTranslation();
  const [contactUsDialogState, setContactUsDialogState] = useState(false);

  return (
    <>
      <footer className="mt-0">
        <div className="p-6 lg:p-8 flex justify-center">
          <div className="w-4/5 flex flex-col place-self-center">
            <div className="flex flex-row justify-between">
              <Link
                to={`${
                  portal === "agent"
                    ? "/dashboard"
                    : location.pathname === "/payee"
                    ? "#"
                    : "/policies"
                }`}
                title="Return to dashboard"
              >
                <img
                  className="w-48"
                  src={getImage("logo_white.png")}
                  alt={`${config.COMPANY_NAME} logo`}
                />
              </Link>
              <div className="flex flex-row flex-strech justify-center">
                <div className="self-center mr-2">
                  <nav aria-label="floating chat button">
                    <button className="block border-2 rounded-full overflow-hidden z-[500] border-ui-blue">
                      <div className="bg-white hover:text-white px-2 py-2 text-ui-blue hover:bg-ui-blue">
                        <svg
                          className="ui-icon w-3 lg:w-5 h-3 lg:h-5"
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-chat-solid"></use>
                        </svg>
                      </div>
                    </button>
                  </nav>
                </div>
                <div className="flex flex-col justify-center">
                  <h3 className="text-sm lg:text-xl">Need Help?</h3>
                  <h3 className="text-xs lg:text-lg">
                    Our Live Chat Representatives are ready to assist you.
                  </h3>
                </div>
              </div>
            </div>
            <hr />
            <div className="flex flex-row justify-between text-xs">
              <div className="flex flex-col-reverse flex-wrap md:flex-row">
                <div className="mr-5" role="presentation">
                  © Copyright {new Date().getFullYear()} NTT DATA
                </div>
                <div>
                  <Link
                    className="inline-flex items-center basis-full mb-1 mr-3 sm:basis-auto"
                    to="/terms-of-use"
                  >
                    {t("Footer-link-4")}
                  </Link>
                  <Link
                    className="inline-flex items-center basis-full mb-1 mr-3 sm:basis-auto"
                    to="/privacy-policy"
                  >
                    {t("Footer-link-5")}
                  </Link>
                </div>
              </div>

              <div className="flex flex-wrap flex-row items-start md:items-center">
                {location.pathname !== "/payee" && (
                  <>
                    <Link to="/help" className="inline-block mr-8">
                      Help
                    </Link>

                    <Link
                      to="/guest/help/help-faqs"
                      className="inline-block mr-8"
                    >
                      FAQs
                    </Link>
                  </>
                )}

                <Link
                  to="#"
                  className="ui-link inline-block mr-8"
                  onClick={() => setContactUsDialogState(true)}
                >
                  {t("Footer-link-2")}
                </Link>
                <a
                  href="https://us.nttdata.com/en/"
                  target="_blank"
                  className="inline-flex items-center basis-full mr-8 sm:basis-auto"
                  rel="noreferrer"
                >
                  <svg
                    className="ui-icon w-3 h-3 mr-2"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-external-link"></use>
                  </svg>
                  Visit Our Site
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ContactUsDialog
        dialogState={contactUsDialogState}
        setDialogState={setContactUsDialogState}
      />
    </>
  );
}
